import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import {
  CalendarEventDateIcon,
  CalendarEventDateString
} from 'components/calendar';
import {
  EmptyIndicator,
  FlexContainer,
  LoadingIndicator,
  TitleWithIcon
} from 'components/common';
import { BoxRow } from 'components/common/box';
import { ParticipantsStats } from 'components/common/stats';
import { MyTeamFollowBox, useMyTeamFollowContext } from '.';

import type { GetTeamCalendarEventsRes } from 'shared-types/responses';

const MyTeamCalendarEvents = () => {
  const { messages, user } = useReduxState();

  const { queryString, queryParams } = useMyTeamFollowContext();

  const { data, loading } = useApiData<GetTeamCalendarEventsRes>({
    url:
      `/admin/supervisors/${user.id}/team-calendar-events` +
      (queryString.length ? `?${queryString}` : ''),
    onlyIf: Boolean(user.id)
  });

  return (
    <MyTeamFollowBox
      numberOfPages={data?.calendarEvents?.length ? data?.pages || 1 : 0}
      title={messages.commonCalendarEvents}
    >
      {loading ? (
        <LoadingIndicator />
      ) : data?.calendarEvents?.length ? (
        data.calendarEvents.map((calendarEvent) => (
          <BoxRow key={calendarEvent.id}>
            <div className="row-sm row-center">
              <div className="col">
                <FlexContainer style={{ gap: 15, minWidth: 250 }}>
                  <CalendarEventDateIcon
                    startDate={calendarEvent.startDate}
                    useMonthSpecifier={true}
                  />

                  <TitleWithIcon
                    title={calendarEvent.title}
                    titleLink={{
                      as: `/my-team/follow/calendar-events/${calendarEvent.id}`,
                      href: '/my-team/follow/calendar-events/[calendarEventId]'
                    }}
                  >
                    <CalendarEventDateString
                      startDate={calendarEvent.startDate}
                      endDate={calendarEvent.endDate}
                    />
                  </TitleWithIcon>
                </FlexContainer>
              </div>
              <div className="col-min">
                <ParticipantsStats
                  completedLabel={messages.eventCalendarParticipantParticipated}
                  completionEnabled={true}
                  inProgressLabel={messages.commonAdded}
                  notStartedLabel={messages.commonNotAdded}
                  progressData={{
                    completed: calendarEvent.progressData?.participated,
                    started: calendarEvent.progressData?.added,
                    participants: calendarEvent.progressData?.users
                  }}
                  showNotStarted={queryParams['participantsOnly'] !== 'true'}
                />
              </div>
            </div>
          </BoxRow>
        ))
      ) : (
        <EmptyIndicator
          icon={['far', 'calendar-days']}
          title={messages.eventCalendarEmpty}
        />
      )}
    </MyTeamFollowBox>
  );
};

export default MyTeamCalendarEvents;
